<template>
    <AdaptersDialog
        :header="title"
        :listener-id="getListenerId"
        :listener-close-id="getListenerCloseId"
        :loading="loading"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
    >
        <template #content>
            <div class="modal-body">
                <AdaptersChart :chart-data="getChartData" :chart-options="getChartOptions" />
            </div>
        </template>
    </AdaptersDialog>
</template>

<script>
    import axios from 'axios'
    import {Listeners} from "../../../constants/listeners";
    import AdaptersDialog from "../../adapters/Dialog.vue";
    import AdaptersChart from "../../adapters/Chart.vue";

    export default {
        name: "domain-history-by-keys",
        mounted() {
            this.$emitter.on(Listeners.KS_TABLE_DOMAIN_HISTORY_BY_KEYS, model => {
                this.model = model;
                this.$emitter.emit(Listeners.KS_TABLE_POPUP_DOMAIN_HISTORY_BY_KEYS_OPEN);
            });
        },
        data() {
            return {
                loading: false,
                error: null,
                model: {},
                title: "",
                Chart: null,
                chartData: null,
                chartOptions: null,
            }
        },
        methods: {
            onClose() {
                this.chartData = null;
            },
            onOpen() {
                let url = new URL(window.location.href);
                let domain = url.searchParams.get("domain");
                this.title = this.$t('lang.main.table.components.domain_history_by_keys.title', [domain, window.db.caption]);
                this.loading = true;
                this.setChartOptions();

                let self = this;
                axios({
                    method: 'get',
                    url: this.getApiUrl,
                    withCredentials: true,
                    params: {domain: domain, did: this.model.did, kid: this.model.kid, base: window.db.name},
                })
                .then(response => self.setChartData(response.data))
                .catch(error => {
                    // console.log(error);
                    // self.error = error.response.data.message;
                })
                .finally(() => self.loading = false);
            },
            setChartOptions() {
                this.chartOptions = {
                    plugins: {
                        title: {
                            display: true,
                            text: this.$t('lang.main.table.components.domain_history_by_keys.keyword', [this.model.word]),
                        },
                    },
                    scales: {
                        y: {
                            reverse: true,
                            suggestedMax: 50,
                            ticks: {
                                callback: (value) => value === 0 ? 1 : value,
                                stepSize: 10,
                            },
                        }
                    },
                };
            },
            setChartData(chartData) {
                const labels = chartData.map(item => ('0' + item.m).slice(-2) + "/" + item.y);
                const data = chartData.map(item => item.pos);

                this.chartData = {
                    labels: labels,
                    datasets: [{
                        label: this.$t('lang.main.table.components.domain_history_by_keys.pos'),
                        data,
                        fill: false,
                        borderColor: "rgb(54, 162, 235)",
                        borderWidth: 1,
                    }]
                };
            },
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/report/simple/domain_history_by_keywords';
            },
            getListenerId() {
                return Listeners.KS_TABLE_POPUP_DOMAIN_HISTORY_BY_KEYS_OPEN;
            },
            getListenerCloseId() {
                return Listeners.KS_TABLE_POPUP_DOMAIN_HISTORY_BY_KEYS_CLOSE;
            },
            getChartData() {
                return this.chartData;
            },
            getChartOptions() {
                return this.chartOptions;
            }
        },
        components: {
            AdaptersDialog,
            AdaptersChart,
        }
    }
</script>
